import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = {
  class: "table align-middle table-row-bordered table-hover dataTable no-footer",
  role: "grid"
}
const _hoisted_4 = {
  class: "text-start text-gray-400 fw-bolder fs-5 text-uppercase gs-0",
  role: "row"
}
const _hoisted_5 = {
  class: "text-start",
  tabindex: "0",
  rowspan: "1",
  colspan: "1"
}
const _hoisted_6 = {
  class: "text-start",
  tabindex: "0",
  rowspan: "1",
  colspan: "1"
}
const _hoisted_7 = {
  key: 0,
  class: "text-start",
  tabindex: "0",
  rowspan: "1",
  colspan: "1"
}
const _hoisted_8 = {
  class: "text-end",
  tabindex: "0",
  rowspan: "1",
  colspan: "1"
}
const _hoisted_9 = { class: "fw-bold text-gray-800" }
const _hoisted_10 = { colspan: "1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "fs-7 text-gray-400"
}
const _hoisted_14 = { colspan: "1" }
const _hoisted_15 = {
  key: 0,
  colspan: "1"
}
const _hoisted_16 = { colspan: "1" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "dataTables_empty p-0 py-4"
}, [
  /*#__PURE__*/_createElementVNode("p", null, "No data found")
], -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_4, [
            _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.t("orderRequest.salesOrderNo")), 1),
            _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.t("orderRequest.fulfillmentNo")), 1),
            (_ctx.isShowOldFulfillmentId)
              ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(_ctx.t("orderRequest.oldFulOrderNo")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.t("orderRequest.qty")), 1)
          ])
        ]),
        _createElementVNode("tbody", _hoisted_9, [
          (_ctx.props.items.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.props.items, (re, reIndex) => {
                return (_openBlock(), _createElementBlock("tr", { key: reIndex }, [
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(re.sale_order_number), 1),
                      _hoisted_11
                    ]),
                    (_ctx.isShowSubPosition)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (re.sales_order_sub_total > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "SUB#" + _toDisplayString(re.sales_order_sub_position) + " of " + _toDisplayString(re.sales_order_sub_total), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(re.fulfillment_order_number), 1),
                  (_ctx.isShowOldFulfillmentId)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(re.old_fulfillment_id), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(re.dispatch_qty), 1)
                  ])
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_18, _hoisted_20))
        ])
      ])
    ])
  ]))
}